import { Component, ViewEncapsulation, ChangeDetectionStrategy, Output, EventEmitter, Input } from '@angular/core';

import { ChubbAssistanceTerms } from '@app/entities/asset-chubb-booking-banner';
import { AssetChubbBookingBanner } from '@asset-chubb-booking-banner';
import { AssistanceSearchInclusionDetail } from '@shared/travel-assistance/entities/booking-assistance';
import { environment } from '@environment';

@Component({
  selector: 'app-chubb-details-and-terms',
  templateUrl: './chubb-details-and-terms.component.html',
  styleUrls: ['./chubb-details-and-terms.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ChubbDetailsAndTermnsComponent {

  @Input() isMobile: boolean;
  @Input() assistanceValues: AssistanceSearchInclusionDetail[] = [];
  @Input() innerView: boolean;
  @Input() isCrossSelling: boolean;

  @Output() closeDetail: EventEmitter<void> = new EventEmitter<void>();

  public readonly CHUBB_BOOKING_IMAGES_BASE_PATH: string = 'web/travel/Chubb/Booking';
  public readonly CHUBB_LOGO: string = 'chubb-logo.png';

  public showPdf: boolean = false;
  public srcPdf: string = environment.chubb_terms_pdf;
  public termsIsActive: boolean = false;
  constructor() { }

  get terms(): ChubbAssistanceTerms[] {
    return AssetChubbBookingBanner?.ASSISTANCE.ASSISTANCE_TERMS;
  }

  get termsLabel(): string {
    return AssetChubbBookingBanner?.ASSISTANCE.TERMS_SWITCH_LABEL;
  }

  get termsContTitle(): string {
    return AssetChubbBookingBanner?.ASSISTANCE.TERMS_TITLE;
  }

  get valuesLabel(): string {
    return AssetChubbBookingBanner?.ASSISTANCE?.VALUES_SWITCH_LABEL;
  }

  get insuredLimitLabel(): string {
    return AssetChubbBookingBanner?.ASSISTANCE?.INSURED_LIMIT_LABEL;
  }

  get isActiveDetails(): boolean {
    return !this.termsIsActive;
  }

  get isActiveTerms(): boolean {
    return !!this.termsIsActive;
  }

  public toggleTermsIsActive(value: boolean): void {
    this.termsIsActive = !!value;
  }

  public openPDF(): void {
    if (this.isMobile) {
      this.toggleOpenPdfView();
    } else if (typeof window !== 'undefined') {
      window.open(this.srcPdf, '_blank');
    }
  }

  public toggleOpenPdfView(): void {
    this.showPdf = !this.showPdf;
  }

}
